<template>
	<v-card-text>
		<v-content align="center" justify="center" class="pa-5">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-3 text-wrap"><h2>Complete your profile</h2></v-list-item-title>
					<v-list-item-subtitle>
						<subtitle-1>Complete the following sections before proceeding to the dashboard</subtitle-1>
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-content>

		<v-item-group class="ml-5 mr-5">
			<v-content>
				<v-row>
					<v-col v-for="n in required_forms" :key="n.context" cols="12" md="3">
						<v-item v-slot="{}">
							<profile-step-button
								:image_o="n.image_o"
								:image_g="n.image_g"
								:image_w="n.image_w"
								:image_width="n.image_width"
								:image_height="n.image_height"
								:form="n.form"
								:text="n.text"
								:context="n.context"
								:button-colour="buttonColours[n.context]"
							></profile-step-button>
						</v-item>
					</v-col>
				</v-row>
			</v-content>
		</v-item-group>
	</v-card-text>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';

import ProfileStepButton from '@/components/locum/profile/ProfileStepButton.vue';

import { Tracking } from '@/utils';

export default {
	components: {
		ProfileStepButton,
	},
	props: {
		required_forms: Array,
	},
	data: () => ({
		name: 'CompleteProfileStepsForm',
		buttonColours: [],
	}),

	created() {
		this.buttonColours = store.getters.getProfileButtonColours;
	},

	mounted() {
		Tracking.track('Practice_Complete_Profile', {});
		bus.$on('intent:submit-forms:complete-profile-steps', () => {
			bus.$off('intent:submit-forms:complete-profile-steps');
			bus.$emit('intent:next-step', 'complete-profile-steps');
		});
		bus.$emit('update:create-account-step@status', 'positive');
		bus.$emit('update:verification-step@status', 'busy');
	},

	beforeDestroy() {
		bus.$off('intent:submit-forms:complete-profile-steps');
	},
};
</script>
